module.exports = __webpack_public_path__ + "assets/img/pay-success.8ad2e0f3.png";